import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import Vue2TouchEvents from 'vue2-touch-events';
import ENVIRONMENT from './config/environment';

Vue.use(Vuex);
Vue.use(Vue2TouchEvents, {
  touchClass: 'active',
});

export default new Vuex.Store({
  state: {
    ratings: [],
    statistics: [],
    shareDescription: 'Test',
    shareDescriptionNumber: '',
    shareDescriptonData: [],
  },
  actions: {
    loadStatistic({ commit }) {
      axios
        .get(`${ENVIRONMENT.VUE_APP_API_URL}/api/question/correct`)
        .then(response => response.data)
        .then((statistics) => {
          commit('setStatisticList', statistics);
        });
    },
    loadRating({ commit }) {
      axios
        .get(`${ENVIRONMENT.VUE_APP_API_URL}/api/rating`)
        .then(response => response.data)
        .then((ratings) => {
          commit('setRatingList', ratings);
        });
    },
    loadShareDescription({ commit }) {
      axios
      .get(`${ENVIRONMENT.VUE_APP_API_URL}/api/sharing`)
      .then(response => response.data)
      .then((shareDescription) => {
        commit('setShareDescription', shareDescription);
      }).catch(error => {
        // eslint-disable-next-line
        console.log(error);
      });
    },
  },
  mutations: {
    setStatisticList(state, statistics) {
      // eslint-disable-next-line
      state.statistics = statistics;
    },
    setRatingList(state, ratings) {
      // eslint-disable-next-line
      state.ratings = ratings;
    },
    setShareDescription(state, shareDescription) {
      // eslint-disable-next-line
      state.shareDescriptonData = shareDescription;
      state.shareDescriptionNumber = Math.floor(Math.random() * (state.shareDescriptonData.length - 1)) + 1;
      state.shareDescription = state.shareDescriptonData[state.shareDescriptionNumber] || 'Test';
    },
  },
});
